import { useMemo } from "react";
import countries from "@ntpu/i18n-iso-countries";
import { SelectFieldOption } from "../components/SelectField";
import { Locale } from "../i18n/types";
import { useI18n } from "../i18n";

const i18nIsoCountriesLocaleCode: Record<Locale, string> = {
  [Locale.en]: "en",
  [Locale.zhHant]: "tw",
};

export function useGetCountryOptions(): SelectFieldOption[] {
  const { locale } = useI18n();

  return useMemo(() => {
    const alpha2NameDict = countries.getNames(
      i18nIsoCountriesLocaleCode[locale]
    );
    const alpha2List = Object.keys(alpha2NameDict);
    const options: SelectFieldOption[] = [];
    for (const alpha2 of alpha2List) {
      const names = alpha2NameDict[alpha2];
      options.push({
        name: Array.isArray(names) ? names[0] : names,
        value: countries.alpha2ToAlpha3(alpha2),
      });
    }
    return options.sort((a, b) => (a.name > b.name ? 1 : -1));
  }, [locale]);
}
